export default "__VITE_ASSET__D9wILA6Y__"